"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customCurrDateCell = ({ dataIndex, dataItem, field, style }) => {
    const itemData = dataItem;
    const rowColor = [6, 10, 14, 15].includes(dataIndex + 1);
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 1, role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, className: 'k-grid-content-sticky', id: `m_grid_cell_${field}_${dataIndex}`, style: Object.assign(Object.assign({}, style), { fontSize: 14, color: '#FFFFFF', backgroundColor: rowColor ? '#727272' : '#B5B5B5' }) }, { children: field && itemData[field].toString() })));
};
exports.default = customCurrDateCell;
